<div class="header">
  <div class="section-title">{{ "chatProperty.propertyDetails" | translate }}</div>
  <div class="context">{{ "chatProperty.context" | translate }}</div>
</div>

<div class="scrollable-content">
  @if (property()?.propertyPhotos?.length) {
    <div class="image-container">
      <img class="image-container" src="{{ property()?.propertyPhotos?.[0] | resource }}" alt="" />
      <div class="badge">{{ property()?.numberOfRooms }} {{ "chatProperty.rooms" | translate }}</div>
    </div>
  }

  <div class="property-header">
    <div class="property-title pb-2">{{ details()?.title ?? "" | translate }}</div>
    <div class="property-address">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <span>{{ details()?.address ?? "address.notAvailable" | translate }}</span>
    </div>
  </div>

  <div class="card price-card">
    <div class="price-value">€{{ details()?.rent }}</div>
    <div class="price-period">{{ "chatProperty.perMonth" | translate }}</div>
  </div>

  <div class="facts-row">
    <div class="card fact-card">
      <div class="fact-value">{{ details()?.rooms }}</div>
      <div class="fact-label">{{ "chatProperty.rooms" | translate }}</div>
    </div>
    <div class="card fact-card">
      <div class="fact-value">{{ details()?.size }}</div>
      <div class="fact-label">m²</div>
    </div>
  </div>

  <div class="section">
    <div class="section-title">{{ "chatProperty.featuresAndAmenities" | translate }}</div>
    <div class="features-grid">
      <div class="card feature-item" *ngFor="let feature of mappedFeatures()">
        <span class="feature-emoji">{{ feature?.icon }}</span>
        <span class="feature-label">{{ feature?.name ?? "" | translate }}</span>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="section-title">{{ "chatProperty.description" | translate }}</div>
    <p class="description-text">
      {{ swapRequest()?.property?.description }}
    </p>
  </div>

  <div class="card owner-card">
    <div class="section-title">{{ "chatProperty.ownerInformation" | translate }}</div>
    <div class="owner-info">
      <div class="avatar">{{ swapRequest()?.user?.name?.charAt(0) }}</div>
      <div class="owner-meta">
        <div class="owner-name">{{ swapRequest()?.user?.name }} {{ swapRequest()?.user?.surname }}</div>
      </div>
    </div>
    <div class="owner-details">
      <div class="detail-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M8 2v4"></path>
          <path d="M16 2v4"></path>
          <rect width="18" height="18" x="3" y="4" rx="2"></rect>
          <path d="M3 10h18"></path>
        </svg>
        <span>{{ "chatProperty.memberSince" | translate }} {{ swapRequest()?.user?.createdAt | date }}</span>
      </div>
    </div>
  </div>

  <button [routerLink]="['/swap-request-details', swapRequest()?.id]" class="card btn btn-primary">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path d="M15 3h6v6"></path>
      <path d="M10 14 21 3"></path>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    </svg>
    <span>{{ "chatProperty.viewFullListing" | translate }}</span>
  </button>

  <!--  <div class="button-row">-->
  <!--    <button class="card btn btn-secondary">-->
  <!--      <svg-->
  <!--        xmlns="http://www.w3.org/2000/svg"-->
  <!--        width="16"-->
  <!--        height="16"-->
  <!--        viewBox="0 0 24 24"-->
  <!--        fill="none"-->
  <!--        stroke="currentColor"-->
  <!--        stroke-width="2"-->
  <!--        stroke-linecap="round"-->
  <!--        stroke-linejoin="round">-->
  <!--        <path-->
  <!--          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>-->
  <!--      </svg>-->
  <!--      <span>{{ "chatProperty.call" | translate }}</span>-->
  <!--    </button>-->
  <!--    <button class="card btn btn-secondary">-->
  <!--      <svg-->
  <!--        xmlns="http://www.w3.org/2000/svg"-->
  <!--        width="16"-->
  <!--        height="16"-->
  <!--        viewBox="0 0 24 24"-->
  <!--        fill="none"-->
  <!--        stroke="currentColor"-->
  <!--        stroke-width="2"-->
  <!--        stroke-linecap="round"-->
  <!--        stroke-linejoin="round">-->
  <!--        <rect width="20" height="16" x="2" y="4" rx="2"></rect>-->
  <!--        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>-->
  <!--      </svg>-->
  <!--      <span>{{ "chatProperty.email" | translate }}</span>-->
  <!--    </button>-->
  <!--  </div>-->

  @if (details()?.address && property()?.mapLocation?.coordinates?.length) {
    <a
      target="_blank"
      href="https://www.google.com/maps/search/?api=1&query={{ property()?.mapLocation?.coordinates?.[1] }},{{
        property()?.mapLocation?.coordinates?.[0]
      }}">
      <div class="card location-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="location-icon">
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <div class="section-title">{{ "chatProperty.location" | translate }}</div>
        <div class="location-address">
          {{ details()?.address ?? "address.notAvailable" | translate }}
        </div>
      </div>
    </a>
  }
</div>
